import React from "react";

const Badge = ({ skill }) => {
  return (
    <div className='text-dark text-sm xs:text-base md:text-lg font-["Poppins"] bg-scColor py-1 px-2 inline-block rounded ring-dark ring-1'>
      {skill}
    </div>
  );
};

export default Badge;
